import analytics from '@utils/analytics';
import whatInput from 'what-input';
import BaseComponent from '../base/baseComponent';
export default class MyAccountHeaderComponent extends BaseComponent {
    constructor(element) {
        super(element);
        this.isDesktop = window.isDesktop();
        // console.info('sono loggato?', this.$options.auth);
        this.$el.querySelectorAll('.account-cta').forEach((el) => {
            el.addEventListener('click', () => analytics.header('account', true));
        });
        this.accountCta = this.$el.querySelector(this.SELECTORS.button);
        if (this.accountCta) {
            this.handleKeyboardNavigation();
            this.handleMouseHover();
        }
    }
    get SELECTORS() {
        return {
            button: '.js-account-cta',
        };
    }
    get CLASSES() {
        return {
            open: 'open',
        };
    }
    get Messages() {
        return {
            [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
        };
    }
    handleKeyboardNavigation() {
        this.$on('click', (e) => {
            if (whatInput.ask() === 'keyboard' || whatInput.ask() === 'touch') {
                if (!document.body.classList.contains('no-overflow')) {
                    if (this.accountCta.getAttribute('aria-expanded') == 'false') {
                        this.accountCta.setAttribute('aria-expanded', 'true');
                        document.body.classList.add('overlay-open');
                    }
                    else {
                        this.accountCta.setAttribute('aria-expanded', 'false');
                        document.body.classList.remove('overlay-open');
                        analytics.closeMyMonclerMenu();
                    }
                }
            }
            else {
                document.location.href = this.accountCta.dataset.href;
            }
        }, this.accountCta);
        const focusable = this.getFocusableElements(this.$el);
        const actualFocussable = Array.from(focusable).filter((el) => window.getComputedStyle(el).display != 'none');
        actualFocussable.forEach((el) => {
            this.$on('keydown', (e) => {
                if (e.key == 'Escape') {
                    this.accountCta.setAttribute('aria-expanded', 'false');
                    document.body.classList.remove('overlay-open');
                    analytics.closeMyMonclerMenu();
                }
            }, el);
        });
        const lastFocusable = actualFocussable[actualFocussable.length - 1];
        this.$on('keydown', (e) => {
            if (e.key == 'Tab' && !e.shiftKey) {
                this.accountCta.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('overlay-open');
                analytics.closeMyMonclerMenu();
            }
        }, lastFocusable);
    }
    handleMouseHover() {
        if (this.isDesktop) {
            this.$on('mouseenter', (e) => {
                clearTimeout(this.exitDebounce);
                clearTimeout(this.enterDebounce);
                this.hoverStatus = true;
                this.enterDebounce = setTimeout(() => {
                    analytics.header('account');
                    if (!document.body.classList.contains('no-overflow')) {
                        this.hoverStatus && this.accountCta.setAttribute('aria-expanded', 'true');
                        document.body.classList.add('overlay-open');
                    }
                }, 200);
            });
            this.$on('mouseleave', () => {
                clearTimeout(this.exitDebounce);
                clearTimeout(this.enterDebounce);
                this.hoverStatus = false;
                this.exitDebounce = setTimeout(() => {
                    this.accountCta.setAttribute('aria-expanded', 'false');
                    document.body.classList.remove('overlay-open');
                    analytics.closeMyMonclerMenu();
                }, 200);
            });
        }
    }
    onBreakpointChange(br) {
        if (br.value >= window.mqObj['md'] && !this.isDesktop) {
            this.isDesktop = true;
            if (this.accountCta) {
                this.handleMouseHover();
            }
        }
        else if (br.value < window.mqObj['md'] && this.isDesktop) {
            this.isDesktop = false;
            this.$off('mouseenter');
            this.$off('mouseleave');
        }
    }
}
